module.exports = __webpack_public_path__ + "static/media/user.59c05482.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_130/imgs/user.png
// module id = 384
// module chunks = 0